import styled from 'styled-components';

const SnippetStyles = styled.div`
  .snippet-text {
    margin: 20px 0;
  }
`;

export default SnippetStyles;
